import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import * as Sentry from "@sentry/angular"
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DEV_ENV_NAME } from './constants/env';
import { AuthService } from './services/auth.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private injector: Injector
    ) { }

    private get authService(): AuthService {
        return this.injector.get(AuthService);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                let error;
                if (err.error) {
                    error = err.error.message || err.error.detail
                } else {
                    error = err.statusText || err;
                }
                return throwError(error);
            })
        )
        .pipe(map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                if (event.body.responseCode == 401) {
                    // Requests tagged X-Background-Request (e.g. CallService's automatic, native
                    // call-triggered lead lookup) fire invisibly to the user, often alongside their
                    // own navigation on completion. Forcing navigation to /auth/login here would race
                    // with that, leaving the app on a blank screen (issue #313). Any future
                    // fire-and-forget/background request can opt out the same way.
                    if (request.headers.has('X-Background-Request')) {
                        return event;
                    }
                    const currentRoute = this.router.url || window.location.hash.replace(/^#/, '');
                    if (currentRoute && currentRoute.indexOf('/auth/') !== 0) {
                        this.authService.rememberOidcRetryRoute(currentRoute);
                    }
                    this.router.navigateByUrl("/auth/login");
                } else if (event.body.responseCode == 500) {
                    if (event.body.error) {
                        const newError = new Error(event.body.error);
                        if (environment.envName === DEV_ENV_NAME) {
                            console.error("TSTERR intercept", newError);
                        } else {
                            console.error(newError);
                        }
                        Sentry.withScope(scope => {
                            scope.setExtra("errorExtraData", newError);
                            scope.setExtra("handlerSource", "interceptor");
                            if (environment.envName !== DEV_ENV_NAME) {
                                var eventId = Sentry.captureException(newError);
                            }
                        });
                        // Sentry.showReportDialog({
                        //     eventId: eventId,
                        // });
                    }
                } else if (event.status !== 200){
                    console.error("HTTP interceptor error", event.body.error || event);
                }
            }
            return event;
        }));
    }
}
